import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { canUseDOM } from "../utils/canUseDOM";
export var SWIPE_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
export function useSwipe(_ref) {
  var ref = _ref.ref,
      callback = _ref.callback;

  var _useState = useState({
    x: 0,
    y: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      startPosition = _useState2[0],
      setStartPosition = _useState2[1];

  var _useState3 = useState({
    x: 0,
    y: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      endPosition = _useState4[0],
      setEndPosition = _useState4[1];

  function handleTouchStart(event) {
    var _event$changedTouches = event.changedTouches[0],
        clientX = _event$changedTouches.clientX,
        clientY = _event$changedTouches.clientY;
    setStartPosition({
      x: clientX,
      y: clientY
    });
  }

  function handleTouchEnd(event) {
    var _event$changedTouches2 = event.changedTouches[0],
        clientX = _event$changedTouches2.clientX,
        clientY = _event$changedTouches2.clientY;
    setEndPosition({
      x: clientX,
      y: clientY
    });
  }

  useEffect(function () {
    var startX = startPosition.x,
        startY = startPosition.y;
    var endX = endPosition.x,
        endY = endPosition.y;
    var xDiff = endX - startX;
    var yDiff = endY - startY;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      callback(xDiff > 0 ? SWIPE_DIRECTION.RIGHT : SWIPE_DIRECTION.LEFT);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [endPosition]);
  useEffect(function () {
    var currentElement = ref.current;

    if (currentElement) {
      if (canUseDOM && 'ontouchstart' in window) {
        currentElement.addEventListener('touchstart', handleTouchStart);
        currentElement.addEventListener('touchend', handleTouchEnd);
      }
    }

    return function () {
      if (currentElement) {
        if (canUseDOM && 'ontouchstart' in window) {
          currentElement.removeEventListener('touchstart', handleTouchStart);
          currentElement.removeEventListener('touchend', handleTouchEnd);
        }
      }
    };
  }, [ref]);
}